import React from 'react';
import './App.css';
import MainRoutes from './routes/Routes';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { WebsiteProvider } from './context/WebsiteContext';

function App() {
  return (<React.Fragment>
    <PayPalScriptProvider options={{ "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID, currency: "GBP" }}>
      <WebsiteProvider>
        <MainRoutes />
      </WebsiteProvider>
    </PayPalScriptProvider>
  </React.Fragment>);
}

export default App;